export default function(input) {
  let string = input.toLowerCase();
  
  // eslint-disable-next-line
  string = string.replace(/\W+/g, "-");

  if (string.charAt(string.length - 1) === '-') {
    // eslint-disable-next-line
    string = string.replace(/-+\z/, '');
  }

  if (string.charAt(0) === '-') {
    // eslint-disable-next-line
    string = string.replace(/\A-+/, '');
  }

  return string;
}